module.exports = __webpack_public_path__ + "img/6.4cacda87.png";